import type { ButtonProps } from '@packages/shared';
import { useTransition } from 'react';
import { Box, Button, CircularProgress } from '@packages/shared';
import type { SetSelectedVariation } from '../../../types/types';

export type TileButtonProps = Omit<ButtonProps, 'onClick'> & {
  active: boolean;
  onClick?: SetSelectedVariation;
  sku: string;
};

export const TileButton = ({ active, onClick, sku, children, ...rest }: TileButtonProps) => {
  const [isLoading, startTransition] = useTransition();

  return (
    <Button
      {...rest}
      onClick={() => {
        if (!active) {
          onClick && startTransition(() => onClick(sku));
        }
      }}
    >
      {isLoading && (
        <CircularProgress
          sx={{ position: 'absolute', transform: 'translate(-50%, -50%)' }}
          size="s"
          color="secondary"
        />
      )}
      <Box
        sx={{
          p: 1,
          ...(isLoading && { visibility: 'hidden' }),
        }}
      >
        {children}
      </Box>
    </Button>
  );
};
